import { FC } from "react";

import EmptyModal from "~/components/EmptyModal/EmptyModal";
import { SiteListObject } from "~/entities/siteEntities";

import styles from "./SiteInfoModal.module.css";
import LocationIcon from "~/icons/LocationIcon";
import {
  getApplicableStoreHours,
  getReadableAvailability,
  getMappedStoreAvailability,
  isStoreOpen,
  siteHasStoreHours,
} from "~/helpers/siteHelpers";
import clsx from "clsx";
import ClockIcon from "~/icons/ClockIcon";
import HourglassIcon from "~/icons/HorglassIcon";
import { Availability } from "~/entities/baseEntities";

type SiteInfoModalProps = {
  site: SiteListObject | null;
  onClose: VoidFunction;
};

const SiteInfoModal: FC<SiteInfoModalProps> = ({ site, onClose }) => {
  return (
    <EmptyModal visible={!!site} onClose={onClose}>
      {site && (
        <div className={styles.content}>
          <div className={styles.title}>{site?.name}</div>
          <div className={styles.siteWidget}>
            <LocationIcon color="#58348E" />
            <div className={styles.siteAddress}>
              <div className={styles.siteCity}>
                {site?.address.city || "City not specified"}
              </div>
              <div className={styles.siteAddress}>{site?.address.address1}</div>
            </div>
            <div
              className={clsx(
                styles.siteStatus,
                !isStoreOpen(site) && styles.siteClosed
              )}
            >
              {isStoreOpen(site) ? "Open now" : "Closed now"}
            </div>
          </div>
          {siteHasStoreHours(site) && (
            <div className={styles.openingHours}>
              <div className={styles.sectionTitle}>
                <ClockIcon />
                <span>Pick Up opening hours</span>
              </div>
              {Object.entries(
                getMappedStoreAvailability(
                  getApplicableStoreHours(site).availability
                )
              ).map(([key, values]: [string, Availability[]]) => (
                <div key={key} className={styles.sectionRow}>
                  <div>{key.replace(/^\w/, (c) => c.toUpperCase())}</div>
                  <div>{`${getReadableAvailability(values)}`}</div>
                </div>
              ))}
            </div>
          )}
          <div className={styles.waitTime}>
            <div className={styles.sectionTitle}>
              <HourglassIcon />
              <span>Wait times</span>
            </div>
            <div className={styles.sectionRow}>
              <div>Pick up</div>
              <div>10 minutes</div>
            </div>
          </div>
        </div>
      )}
    </EmptyModal>
  );
};

export default SiteInfoModal;
